import { CourseModuleCards, ManualChapter } from "@mikros/library";
import { Confirm, GenerateCourseChaptersCards } from "@mikros/shared-ui";
import { Dialog } from "@progress/kendo-react-dialogs";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

export interface ManualProps {
  duplicateS3File: (
    sourceKey: string,
    destinationKey: string,
    fileType: string
  ) => void;
  handleUploadGiveUrl: (e: CourseModuleCards) => void;
  // handleVideoGeneration: (e: any) => void;
  handleVideoGeneration?: (e: any) => Promise<string | false>;
  handleImageGeneration?: (e: any) => Promise<string | false>;
  // handleAudioGeneration?:(e:any)=>Promise<string|false>;
  handleAudioGeneration?: (e: any) => Promise<{ presignedUrl: string; prompt: string } | false>;

  handleCreateCourseUpdateChapterCards: (
    e: ManualChapter[],
    manualCourse: CourseModuleCards
  ) => Promise<boolean>;
  manualCourse: CourseModuleCards;
  oneChapterDeleteFunction?: Function;
  tenantRole?: string;
  handleUpdateStatusRev: (
    status: string,
    course: CourseModuleCards
  ) => Promise<boolean>;
  handleUpdateStatusAll: (
    status: string,
    course?: CourseModuleCards
  ) => Promise<boolean>;
}

export function Manual(props: ManualProps) {
  const intl = useIntl();
  console.log("hi in manual");
  const navigate = useNavigate();

  const [formDialog, setformDialog] = React.useState<boolean>(false);
  const [manualCourse, setManualCourse] = useState<CourseModuleCards>(
    props.manualCourse
  );

  function handleYes() {
    handleYes();
  }

  const handleChaptersUpdate = async (
    course: CourseModuleCards
  ): Promise<boolean> => {
    console.log("handle chapter manual update");
    let chapters: ManualChapter[] = [];
    for (let i = 0; i < course.chapters.length; i++) {
      const courseChapter = course.chapters[i];
      let manualChapter = {
        chapterName: courseChapter.chapterName,
        courseId: course.courseId,
        createdBy: courseChapter.createdBy,
        date: courseChapter.date,
        chapterId: courseChapter.chapterId,
        description: course.description,
        publishedBy: "",
        publishedDate: "",
        seqNo: courseChapter.seqNo,
        updatedBy: "",
        reviewedBy: "",
        reviewedDate: "",
        cards: courseChapter.cards,
        questions: courseChapter.questions,
      };

      for (let card of manualChapter.cards) {
        card.courseName = course.courseName;
        card.courseId = course.courseId;
        // @ts-ignore
        delete card.entityId;
        // @ts-ignore
        delete card.status;
        // @ts-ignore
        delete card.createdAt;
        // @ts-ignore
        delete card.date;
        // @ts-ignore
        delete card.chapterName;
        // @ts-ignore
        delete card.entryType;
        // @ts-ignore
        delete card.recType;
        // @ts-ignore
        delete card.updatedAt;
      }

      chapters.push(manualChapter);
    }

    return props.handleCreateCourseUpdateChapterCards(chapters, course);
  };

  useEffect(() => {
    setManualCourse(props.manualCourse);
    console.log("print manual course in manual", props.manualCourse);
  }, [props.manualCourse]);

  return (
    <div>
      {formDialog && (
        <Dialog className="alertDialogue">
          <Confirm
            description={`${intl.formatMessage({
              id: "courses.manual.saveChangeAlert",
            })}`}
            successText={`${intl.formatMessage({
              id: "users.cohortList.deletionSuccess",
            })}`}
            failureText={`${intl.formatMessage({
              id: "users.cohortList.deletionFailure",
            })}`}
            icon={"alertShape.png"}
            iconMsg={`${intl.formatMessage({
              id: "iconMsgAlert",
            })}`}
            backgroundColor={"mk-orange"}
            onSuccess={() => {
              handleYes();
              navigate("/courses");
            }}
            onFailure={() => {
              navigate("/courses");
            }}
          />
        </Dialog>
      )}

      <GenerateCourseChaptersCards
        isManual={true}
        duplicateS3File={(
          sourceKey: string,
          destinationKey: string,
          fileType: string
        ) => {
          return props.duplicateS3File(sourceKey, destinationKey, fileType);
        }}
        specificCreateCourseFunction={(
          course: CourseModuleCards
        ): Promise<boolean> => {
          return handleChaptersUpdate(course);
        }}
        cards={manualCourse}
        handleUploadGiveUrl={(e: CourseModuleCards) => {
          return props.handleUploadGiveUrl(e);
        }}
   

        handleVideoGeneration={(e: any) => {
          console.log("calling handle video generation", e);
          if (props.handleVideoGeneration) {
            return props.handleVideoGeneration(e);
          }
          return Promise.resolve(false);
        }}
        handleImageGeneration={(e: any) => {
          console.log("calling handle image generation", e);
          if (props.handleImageGeneration) {
            return props.handleImageGeneration(e);
          }
          return Promise.resolve(false);
        }}
        // handleAudioGeneration={(e:any)=>{
        //   console.log("Calling handle audio generation ",e);
        //   if(props.handleAudioGeneration){
        //     return props.handleAudioGeneration(e);
        //   }
        //   return Promise.resolve(false)
        // }}

        handleAudioGeneration={(e: any): Promise<{ presignedUrl: string; prompt: string } | false> => {
          console.log("Calling handle audio generation ", e);
          if (props.handleAudioGeneration) {
            return props.handleAudioGeneration(e);
          }
          return Promise.resolve(false);
        }}
        


        tenantRole={props.tenantRole}
        handleUpdateStatusRev={(
          status: string,
          course: CourseModuleCards
        ): Promise<boolean> => {
          return props.handleUpdateStatusRev(status, course);
        }}
        handleUpdateStatusAll={(
          status: string,
          course: CourseModuleCards
        ): Promise<boolean> => {
          return props.handleUpdateStatusAll(status, course);
        }}
        oneChapterDeleteFunction={props.oneChapterDeleteFunction}
      />
    </div>
  );
}
